import { useMemo } from "react";
import {
  useGetJobCategoryQuery,
  useGetJobCategoriesQuery,
} from "./jobCategoryEndpoints";
import { JobCategory } from "../../entities/jobCategory";

export function useJobCategory(jobCategoryID: number | undefined) {
  const jobCategoryQuery = useGetJobCategoryQuery(jobCategoryID ?? 0, {
    skip: (jobCategoryID ?? 0) <= 0,
  });
  const jobCategoryEntity = jobCategoryQuery.data;

  return useMemo(() => {
    const ret: typeof jobCategoryQuery & {
      jobCategory?: JobCategory | undefined;
    } = {
      ...jobCategoryQuery,
    };
    if (jobCategoryEntity) ret.jobCategory = new JobCategory(jobCategoryEntity);
    return ret;
  }, [jobCategoryEntity]);
}

export function useJobCategories() {
  const jobCategoryQuery = useGetJobCategoriesQuery();
  const jobCategoryEntitiesMap = jobCategoryQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof jobCategoryQuery & {
      jobCategories?: JobCategory[];
      jobCategoriesMap?: { [id: number]: JobCategory };
    } = {
      ...jobCategoryQuery,
      jobCategories: [],
      jobCategoriesMap: {},
    };
    if (jobCategoryEntitiesMap) {
      const jobCategories: JobCategory[] = [];
      const jobCategoriesMap: { [id: number]: JobCategory } = {};

      for (const key in jobCategoryEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(jobCategoryEntitiesMap, key)) {
          const c = jobCategoryEntitiesMap[key];
          const jobCategory = new JobCategory(c);
          jobCategories.push(jobCategory);
          jobCategoriesMap[jobCategory.id] = jobCategory;
        }
      }
      ret.jobCategories = jobCategories;
      ret.jobCategoriesMap = jobCategoriesMap;
    }

    return ret;
  }, [jobCategoryEntitiesMap]);
}
